import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { types } from "../../Helpers/Types";
import { LoginAction } from "../../Actions/Auth/LoginAction";
import { useHistory } from "react-router";


export const SesionScreen = () => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const [state, setState] = useState({
    usuario: "",
    password: "",
    mensajeError: "",
  });
  const onClickLogin = (e) => {
    e.preventDefault();
    setLoading(true);
    LoginAction(state.usuario, state.password)
      .then((result) => {
        setLoading(false);
        history.push(`/auth/multifactor`, {
          idusuario: result.usuario.idusuario,
          actualizarpassword: result.usuario.actualizarpassword,
          token: result.token,
        });
      })
      .catch((error) => {
        setLoading(false);
        if (error.Message !== undefined && error.Message !== null) {
          setState({
            ...state,
            mensajeError: error.Message,
          });
        } else if (error.Mensaje !== undefined && error.Mensaje !== null) {
          setState({
            ...state,
            mensajeError: error.Mensaje,
          });
        } else if (error.errors !== undefined && error.errors !== null) {
          setState({
            ...state,
            mensajeError: "Datos no validos",
          });
        } else if (error !== undefined && error !== null && error !== "") {
          setState({
            ...state,
            mensajeError: error,
          });
        } else {
          setState({
            ...state,
            mensajeError: "Consulta no valida",
          });
        }
        return;
      });
  };

  return (
    <>
      <div className="form-login-controls">
        <div className="labels">
          <label>USUARIO</label>
          <div className="icon-with-text">
            <input
              autoComplete="off"
              id="txt-usuario"
              type="number"
              placeholder="Introduce el usuario"
              value={state.usuario}
              onChange={({ target }) =>
                setState({ ...state, usuario: target.value })
              }
            />
          </div>
        </div>
        <div className="labels">
          <label>CONTRASEÑA</label>
          <div className="icon-with-text">
            <input
              autoComplete="off"
              id="txt-password"
              type="password"
              placeholder="Introduce la contraseña"
              value={state.password}
              onChange={({ target }) =>
                setState({ ...state, password: target.value })
              }
            />
          </div>
        </div>
        {state.mensajeError !== undefined &&
          state.mensajeError !== null &&
          state.mensajeError !== "" ? (
          <div className="mensaje-error scroll-4">
            <div className="mensaje-error-effect">
              <div className="mensaje-error-effect-icono">!</div>
            </div>
            <div className="mensaje-error-effect-contenido">
              {state.mensajeError}
            </div>
          </div>
        ) : (
          <div></div>
        )}

        <button
          id="button-login"
          className="form-login-botton"
          onClick={onClickLogin}
        >
          <div className="form-login-bottom-control-text">INICIAR SESION</div>
        </button>
      </div>
      {loading && (
        <div className="spinner">
          <div className="lds-facebook">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
    </>
  );
};
